import { Component, inject } from '@angular/core';
import { CreateBriefService } from '../../../briefs/service/create-brief/create-brief.service';

type SocialChannel = { channelName: string; shortName: string; channelId: number; channelIcon: string; };

@Component({
  selector: 'agent-step-distribution',
  standalone: true,
  imports: [],
  templateUrl: './distribution.component.html',
  styleUrl: './distribution.component.css'
})
export class DistributionComponent {

  socialChannelOptions: {
    channelName: string;
    shortName: string;
    channelId: number;
    channelIcon: string;
  }[] = [
      {
        channelName: 'UGC Only',
        shortName: 'UGC',
        channelId: -1,
        channelIcon: '../../../../../assets/social-icon/ugc-videos.svg',
      },
      {
        channelName: 'TikTok Post',
        shortName: 'Post',
        channelId: 0,
        channelIcon: '../../../../../assets/social-icon/tik-tok-transparent.svg',
      },
      {
        channelName: 'Instagram Reel',
        shortName: 'Reel',
        channelId: 1,
        channelIcon: '../../../../../assets/social-icon/ig_reels_logo.png',
      },
      {
        channelName: 'Instagram Story',
        shortName: 'Story',
        channelId: 2,
        channelIcon: '../../../../../assets/social-icon/instagram-logo.png',
      },
      {
        channelName: 'YouTube Shorts',
        shortName: 'Short',
        channelId: 3,
        channelIcon: '../../../../../assets/social-icon/youtube_shorts.webp',
      },
      {
        channelName: 'Snapchat Spotlight',
        shortName: 'Spotlight',
        channelId: 4,
        channelIcon: '../../../../../assets/social-icon/snapchat-logo.svg',
      },
      {
        channelName: 'Snapchat Story',
        shortName: 'Story',
        channelId: 5,
        channelIcon: '../../../../../assets/social-icon/snapchat_story.jpg',
      },
    ]

  allVideoFormats = [
    {
      id: 0,
      name: '9:16',
      description: 'Vertical',
      color: 'bg-green-500/10 text-green-400 rounded-l-md border-t border-l border-b border-green-400'
    },
    {
      id: 1,
      name: '16:9',
      description: 'Horizontal',
      color: 'bg-emerald-500/10 text-emerald-400 rounded-l-md border-t border-l border-b border-emerald-400'
    },
    {
      id: 2,
      name: '1:1',
      description: 'Square',
      color: 'bg-teal-500/10 text-teal-400 rounded-l-md border-t border-l border-b border-teal-400'
    },
  ];

  /** Services */
  public createBriefService = inject(CreateBriefService);
  /** Services - END */

  selectChannel(channel: SocialChannel) {
    if (channel.channelId === -1) {
      this.selectUgcOnly(channel);
    } else {
      this.selectInfluencerBrief(channel);
    }
  }

  isChannelItemSelected(channel: SocialChannel): boolean {
    if (channel.channelId === -1) {
      return this.createBriefService.selectedUgcOnly();
    }
    return this.isChannelSelected(channel);
  }

  selectUgcOnly(channel: { channelName: string; shortName: string; channelId: number; channelIcon: string; }) {
    console.log('selectUgcOnly');
    this.createBriefService.selectedUgcOnly.set(!this.createBriefService.selectedUgcOnly());

    this.createBriefService.selectedPrimaryChannel.set(undefined);
    this.createBriefService.selectedCrossPlatformChannels.set([]);
    this.createBriefService.createShoutBrief.set(false);
    this.createBriefService.selectedVideoFormat.set(undefined);
  }

  selectInfluencerBrief(channel: { channelName: string; shortName: string; channelId: number; channelIcon: string; }) {
    console.log('selectInfluencerBrief', channel);
    if (this.createBriefService.selectedUgcOnly()) {
      this.createBriefService.selectedUgcOnly.set(false);
      this.createBriefService.selectedVideoFormat.set(undefined);
    }

    if (this.createBriefService.selectedPrimaryChannel() && this.createBriefService.selectedPrimaryChannel()?.channelId != channel.channelId) {
      const currentChannels = this.createBriefService.selectedCrossPlatformChannels();
      const channelIndex = currentChannels.findIndex(c => c.channelId === channel.channelId);

      if (channelIndex !== -1) {
        this.createBriefService.selectedCrossPlatformChannels.set(
          currentChannels.filter(c => c.channelId !== channel.channelId)
        );
      } else {
        // Channel doesn't exist, add it
        this.createBriefService.selectedCrossPlatformChannels.set([...currentChannels, channel]);
      }
    } else if (this.createBriefService.selectedPrimaryChannel() && this.createBriefService.selectedPrimaryChannel()?.channelId == channel.channelId) {
      if (this.createBriefService.selectedCrossPlatformChannels().length > 0) {
        this.createBriefService.selectedPrimaryChannel.set(this.createBriefService.selectedCrossPlatformChannels()[0]);
        this.createBriefService.selectedCrossPlatformChannels.set(this.createBriefService.selectedCrossPlatformChannels().slice(1));
      } else {
        this.createBriefService.selectedPrimaryChannel.set(undefined);
      }
    } else {
      this.createBriefService.selectedPrimaryChannel.set(channel);
    }

    console.log('selectedUgcOnly: ', this.createBriefService.selectedUgcOnly());
    console.log('selectedPrimaryChannel: ', this.createBriefService.selectedPrimaryChannel());
    console.log('selectedCrossPlatformChannels: ', this.createBriefService.selectedCrossPlatformChannels());
    if (this.createBriefService.selectedPrimaryChannel()) {
      this.createBriefService.createShoutBrief.set(true);
      this.createBriefService.selectedVideoFormat.set({
        id: 0,
        name: '9:16',
        description: 'Vertical',
        color: 'bg-green-500/10 text-green-400 rounded-l-md border-t border-l border-b border-green-400'
      })
    }
    console.log('--------------------------------');
  }

  isChannelSelected(channel: { channelName: string; shortName: string; channelId: number; channelIcon: string; }) {
    if (this.createBriefService.selectedPrimaryChannel() && this.createBriefService.selectedPrimaryChannel()?.channelId == channel.channelId) {
      return true;
    }

    if (this.createBriefService.selectedCrossPlatformChannels().find((c) => c.channelId == channel.channelId)) {
      return true;
    }

    return false;
  }

  onSuggestedCaptionInput(event: Event): void {
    const target = event.target;
    if (target instanceof HTMLTextAreaElement) {
      this.createBriefService.suggestedCaption.set(target.value);
    }
  }

  onSuggestedHastagsInput(event: Event): void {
    const target = event.target;
    if (target instanceof HTMLTextAreaElement) {
      this.createBriefService.suggestedHastags.set(target.value);
    }
  }

  onSuggestedCallToActionLinkInput(event: Event): void {
    const target = event.target;
    if (target instanceof HTMLInputElement) {
      this.createBriefService.callToActionLink.set(target.value);
    }
  }

}
